import { connect } from "react-redux";
import colores from '../../shared/constants/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ConfirmacionTiendaProps {
    open: boolean;
    handleConfirm: () => void;
    handleClose: () => void;
}

const ConfirmacionTienda = (props: ConfirmacionTiendaProps) => {

    return (
        <Dialog
            open={props.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"¿Confirmás la tienda seleccionada?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    La tienda que seleccionaste en este paso se usará como dirección de entrega de la mercadería.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button className="btn btn-danger" type="button" onClick={props.handleClose} style={{ backgroundColor: colores.grisOscuro, borderColor: colores.grisOscuro, padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem" }} >Volver</button>
                <button className="btn btn-danger" type="button" onClick={props.handleConfirm} style={{ backgroundColor: "#E3000B", padding: "0.625rem", marginTop: "1.25rem", inlineSize: "10rem", marginLeft: "1rem" }} >Siguiente</button>

            </DialogActions>
        </Dialog>
    );
};

export default connect() (ConfirmacionTienda);
